import React, { useCallback } from "react";

import cn from "classnames";

import { FieldTeamVisibility } from "@mapmycustomers/shared/enum/FieldVisibility";
import Role from "@mapmycustomers/shared/types/Role";
import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";

import VisibilitySelectField from "../VisibilitySelectField";

import styles from "./RoleItem.module.scss";

interface Props {
  calculatedField?: boolean;
  className?: string;
  disabledFieldVisibilities?: FieldTeamVisibility[];
  field?: SchemaField;
  onChange?: (role: Role, visibility: FieldTeamVisibility) => void;
  phiEnabled?: boolean;
  role: Role;
  value?: FieldTeamVisibility;
}

const RoleItem: React.FC<Props> = ({
  calculatedField,
  className,
  disabledFieldVisibilities,
  field,
  onChange,
  phiEnabled,
  role,
  value,
}) => {
  const handleChange = useCallback(
    (visibility: FieldTeamVisibility) => onChange?.(role, visibility),
    [onChange, role]
  );

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.title}>{role.name}</div>
      <VisibilitySelectField
        calculatedField={calculatedField}
        disabledFieldVisibilities={disabledFieldVisibilities}
        field={field}
        onChange={handleChange}
        phiEnabled={phiEnabled}
        value={value}
      />
    </div>
  );
};

export default RoleItem;
